import { render, staticRenderFns } from "./InstantwinRandom.vue?vue&type=template&id=08f35adc&scoped=true&"
import script from "./InstantwinRandom.vue?vue&type=script&lang=js&"
export * from "./InstantwinRandom.vue?vue&type=script&lang=js&"
import style0 from "./InstantwinRandom.vue?vue&type=style&index=0&id=08f35adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f35adc",
  null
  
)

export default component.exports